import { useEffect } from 'react'

import { getScrollbarWidth } from 'Pods/Shared/Utils/getScrollbarWidth'

const SCROLL_LOCK_CLASS = 'disable-page-scroll'
const SCROLL_PADDING_CLASS = 'scroll-disabled-padding'

// Locks body scroll while an action popover (cart / inbox / notifications) is open, so the
// page can't scroll behind the mobile dimming backdrop. The backdrop only paints below md,
// so - like useUserMenu - the lock is gated on the mobile viewport and released if the
// popover is left open while resizing up to desktop, where the popover is a small floating
// dropdown and the page must stay scrollable. Pads the body by the scrollbar width so the
// disappearing scrollbar doesn't shift layout. Shares `disable-page-scroll` with
// useHamburgerStatus / useUserMenu; tracks its own lock so cleanup never strips a lock
// another overlay owns (see useHamburgerStatus for the swap ordering that keeps the lock).
function useActionScrollLock(isOpen) {

  useEffect(() => {
    if (!isOpen || typeof window.matchMedia !== 'function') {
      return undefined
    }

    const desktopQuery = window.matchMedia('(min-width: 960px)')
    let locked = false

    function syncScrollLock() {
      const shouldLock = !desktopQuery.matches

      if (shouldLock === locked) {
        return
      }

      locked = shouldLock
      document.body.classList.toggle(SCROLL_LOCK_CLASS, shouldLock)

      if (shouldLock && getScrollbarWidth() > 0) {
        document.body.classList.add(SCROLL_PADDING_CLASS)
      } else {
        document.body.classList.remove(SCROLL_PADDING_CLASS)
      }
    }

    syncScrollLock()
    desktopQuery.addEventListener('change', syncScrollLock)

    return () => {
      desktopQuery.removeEventListener('change', syncScrollLock)

      if (locked) {
        document.body.classList.remove(SCROLL_LOCK_CLASS, SCROLL_PADDING_CLASS)
      }
    }
  }, [isOpen])
}

export { useActionScrollLock }
